export const checkConfig = {
  // en: {
  //   reg: new RegExp(/[^a-zA-Z0-9;:'"! ?.,><$%*()-=_+]/g),
  //   content: '不能输入中文和特殊符号',
  // },
  // 'zh-CHS': {
  //   reg: new RegExp(/[^\u4E00-\u9FA5a-zA-Z0-9 。，：；—《》！？/、%*￥‘“’”;:'"!?.,><$%*()-=_+]/g),
  //   content: '不能输入特殊符号',
  // },
  en: {
    // 目前无法区分原文是中还是英文，所以限制改为统一的
    reg: new RegExp(/[#^*_><\r\n]/g),
    content: '不能输入特殊符号',
  },
  'zh-CHS': {
    reg: new RegExp(/[#^*_><\r\n]/g),
    content: '不能输入特殊符号',
  },
};

export const langTypeConfig = {
  en: {
    label: '英文',
    value: 'en',
    other: 'zh-CHS',
    rlogKey: 'set_english_click',
    makerlogKey: 'all_make_irc_en',
  },
  'zh-CHS': {
    label: '中文',
    value: 'zh-CHS',
    other: 'en',
    rlogKey: 'set_Chinese_click',
    makerlogKey: 'all_make_irc_ch',
  },
};
export const defaultLangType = 'en';
export const EditAjaxTips = {
  1: '自动保存中...',
  2: '已自动保存',
  3: '自动保存失败',
};
export const OneLineTxtLength = 140;

export const userGuideConfig = {
  0: {
    btnName: '下一步',
    // eslint-disable-next-line global-require
    src: require('./imgs/guide1.png'),
  },
  1: {
    btnName: '下一步',
    // eslint-disable-next-line global-require
    src: require('./imgs/guide2.png'),
  },
  2: {
    btnName: '下一步',
    // eslint-disable-next-line global-require
    src: require('./imgs/guide3.png'),
  },
  3: {
    btnName: '完成教学',
    // eslint-disable-next-line global-require
    src: require('./imgs/guide4.png'),
  },
};
